import React, {
  useState,
  createContext,
  useCallback,
  ReactNode,
  Context,
  VFC,
} from 'react';
import { AuthParamKeys } from '~/models/Auth/AuthParamModel';
import AuthDialog from '.';
import AutoUserPageAnnouncementDialog from '../UserPageAnnouncement/AutoUserPageAnnouncementDialog';

export type AuthParams = { [key in AuthParamKeys]?: any };

interface State {
  open: boolean;
  isSignup: boolean;
  authParams: AuthParams;
}
const initialState = {
  open: false,
  isSignup: false,
  authParams: {},
};

interface AuthDialogContextProps extends State {
  setIsSignup: (isSignup: boolean) => void;
  handleOpen: (data?: { isSignup?: boolean; authParams?: AuthParams }) => void;
  handleOpenSignupDialog: (authParam?: AuthParams) => void;
  handleClose: () => void;
}

export const AuthDialogContext: Context<AuthDialogContextProps> = createContext(
  {
    ...initialState,
    setIsSignup: (isSignup) => {},
    handleOpen: (data) => {},
    handleOpenSignupDialog: (authParams) => {},
    handleClose: () => {},
  },
);

interface Props {
  isLoggedIn?: boolean;
  children: ReactNode;
}
const AuthDialogContextProvider: VFC<Props> = ({
  isLoggedIn,
  children,
}: Props) => {
  // reducerとstateのどちらで管理するか迷い中
  const [state, setState] = useState<State>(initialState);

  const setIsSignup = (isSignup: boolean) => {
    setState((prev) => ({ ...prev, isSignup }));
  };

  const getOpen = useCallback(
    (open: boolean) => {
      // ログイン中の場合はopenは常にfalseで返す
      if (isLoggedIn) return false;
      return open;
    },
    [isLoggedIn],
  );

  const handleOpenAuthDialog = (data?: {
    isSignup?: boolean;
    authParams?: AuthParams;
  }) => {
    setState((prev) => ({
      ...prev,
      open: getOpen(true),
      ...(typeof data?.isSignup === 'boolean' &&
        !prev.open && {
          isSignup: data?.isSignup,
        }),
      authParams: typeof data?.authParams === 'object' ? data.authParams : {},
    }));
  };

  const handleOpenSignupDialog = (authParams?: AuthParams) => {
    handleOpenAuthDialog({ isSignup: true, authParams });
  };

  const handleCloseAuthDialog = () => {
    setState((prev) => ({ ...prev, open: false, isSignup: false }));
  };

  return (
    <AuthDialogContext.Provider
      // レンダリングパフォーマンスを改善するためには、本来は関数とデータを一緒にproviderのvalueにまとめない方が良い
      value={{
        ...state,
        setIsSignup,
        handleOpen: handleOpenAuthDialog,
        handleOpenSignupDialog,
        handleClose: handleCloseAuthDialog,
      }}
    >
      {children}
      <AuthDialog authParams={state.authParams} />
      {/* ユーザーページ告知ダイアログ */}
      {isLoggedIn && <AutoUserPageAnnouncementDialog />}
    </AuthDialogContext.Provider>
  );
};

export default AuthDialogContextProvider;
